export default __webpack_public_path__ + "static/media/banner.b1a43a1c.webp";